<template>
  <div class="p-grid p-d-flex p-flex-column-reverse p-flex-md-row p-ai-stretch vertical-container p-m-0">
    <div class="p-col-12 p-md-6 p-lg-6 p-p-0">
      <div id="points-of-sale-list" ref="posList">
        <PosListItem v-for="item in posItems" :pos="item" :key="item.id" :selected="item.properties.selected" @click="onPosItemClick(item)" @display-pos-marker="this.displayPosMarker"></PosListItem>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-6 p-p-0">
      <div id="points-of-sale-map" data-mapbox-token=""></div>
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js';
import geocoding from '@mapbox/mapbox-sdk/services/geocoding';
import atob from "atob";
import axios from "axios";
import PosListItem from './components/PosListItem';
import pointsWithinPolygon from '@turf/points-within-polygon'
import distance from '@turf/distance'
import { polygon, point } from '@turf/turf'


const mapId = 'points-of-sale-map';

export default {
  name: 'App',
  components: {PosListItem},
  data() {
    return {
      map: null,
      mapCenterLat: document.body.dataset.mapboxCenterLat ? document.body.dataset.mapboxCenterLat : '46.80',
      mapCenterLng: document.body.dataset.mapboxCenterLng ? document.body.dataset.mapboxCenterLng : '1.434136',
      mapBounds: new mapboxgl.LngLatBounds(
          new mapboxgl.LngLat(-8.7402883, 52.4234851),
          new mapboxgl.LngLat(12.3403151, 40.3936686)
      ),
      mapMarkers: [],
      mapZoom: 4,
      pointsOfSaleInterval: null,
      posItems: [],
      posList: '',
      userPosition: null,
      features: {},
      filteredFeatures: {},
      geocodingService: {},
      popup: null,
      lockSideBar: false
    }
  },
  async mounted() {
    mapboxgl.accessToken = document.body.dataset.mapboxToken ? atob(document.body.dataset.mapboxToken) : 'pk.eyJ1IjoicmJpYXJkZGF0YWlsb3IiLCJhIjoiY2tvanRlbjNzMGhpNzJvcHZxcnN1azJtYSJ9.9wYJ4Bi7A20Asr8RFBbH9A';
    const styleId = document.body.dataset.mapboxStyleId
    this.geocodingService = geocoding({ accessToken: mapboxgl.accessToken })

    this.map = new mapboxgl.Map({
      container: mapId,
      style: styleId,
      center: [+this.mapCenterLng, +this.mapCenterLat],
      wpApiSettings: null,
      zoom: this.mapZoom,
      // maxBounds: this.mapBounds
    });

    // Add zoom and rotation controls to the map.
    this.map.addControl(new mapboxgl.NavigationControl());

    this.map.on('load', async () => {
      try {
        const res = await axios.get(`${window.location.protocol}//${window.location.host}/wp-json/123parebrise/v1/points-of-sale`)
        // const res = await axios.get(`http://123parebrise.lo/wp-json/123parebrise/v1/points-of-sale`)
        this.features = res.data
        this.filteredFeatures = Object.assign({}, res.data)
        this.posItems = [...this.filteredFeatures.features]
        this.posItems.splice(0, this.posItems.length, ...this.featuresWithin(this.map))
      } catch (e) {
        console.error(e)
      }
      this.map.addSource('places', {
        type: 'geojson',
        data: this.filteredFeatures,
        cluster: false,
        clusterMaxZoom: 6
      })

      this.map.addLayer({
        id: 'places',
        type: 'symbol',
        source: 'places',
        minzoom: 4,
        filter: ['!', ['has', 'point_count']],
        layout: {
          'icon-image': 'pin-123pb',
          'icon-size': 0.4,
          'icon-allow-overlap': true
        }
      })
      this.map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'places',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#00A385',
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40
          ]
        }
      })
      this.map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'places',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['Lato Black'],
          'text-size': 15
        },
        paint: {
          'text-color': '#ffffff'
        }
      });

      // let uri = window.location.search.substring(1);
      // let params = new URLSearchParams(uri);
      // // gets param from URL to be used in search
      // if (params.get('search')) {
      //   await this.geocodeString(params.get('search'));
      //   if (this.userPosition) {
      //     this.showUserPin()
      //     await this.map.flyTo({
      //       center: this.userPosition,
      //       zoom: 9
      //     })
      //     this.map.once('moveend', () => {
      //       this.updatePosItems()
      //     })
      //     this.lockSideBar = true
      //   }
      // }

      window.storeLocatorBus.emit('mapReady')
    })

    this.catchMapMovement();

    window.storeLocatorBus.on('doSearch',
        async ({
                 searchType, searchString, geolocSearch, serviceSearch
               }) => {
      if (serviceSearch && serviceSearch instanceof Array && serviceSearch.length > 0) {
        this.filteredFeatures.features = this.features.features.filter((f) => {
          return serviceSearch.some(filter => {
            return f.properties.services.includes(filter)
          })
        })
        this.map.getSource('places').setData(this.filteredFeatures)
        this.posItems.splice(0, this.posItems.length, ...this.featuresWithin(this.map))
      }

      if (searchType === 'geoloc' && geolocSearch && geolocSearch.lat && geolocSearch.lng) {
        this.userPosition = [geolocSearch.lng, geolocSearch.lat]

        this.showUserPin()
        await this.map.flyTo({
          center: this.userPosition,
          zoom: 9
        })
        this.map.once('moveend', () => {
          this.updatePosItems()
        })
        this.lockSideBar = true
      }

      else if (searchType === 'near' && searchString) {
        if (searchString instanceof String) {
          await this.geocodeString(searchString)
        } else if (searchString instanceof Object && searchString.center) {
          this.userPosition = searchString.center
        }

        if (this.userPosition) {
          this.showUserPin()
          await this.map.flyTo({
            center: this.userPosition,
            zoom: 9
          })
          this.map.once('moveend', () => {
            this.updatePosItems()
          })
          this.lockSideBar = true
        }
      }

    })
  },
  methods: {
    // onSearch () {
    //   console.log('searching')
    //   window.storeLocatorBus.emit('doSearch', {
    //     serviceSearch: ['glazing_repair']
    //   })
    // },
    async geocodeString (searchString) {
      const center = this.map.getCenter()
      const geocode = await this.geocodingService.forwardGeocode({
        query: searchString,
        mode: 'mapbox.places',
        countries: ['FR', 'BE', 'DE', 'CH'],
        proximity: [center.lng, center.lat],
        types: ['postcode', 'locality', 'address', 'place']
      }).send()
      if (geocode.body && geocode.body.features && geocode.body.features.length > 0) {
        this.userPosition = geocode.body.features[0].center
      }
    },
    catchMapMovement() {
      this.map.on('click', 'places', async (e) => {
        let clicked = this.features.features.find((f) => f.id === e.features[0].id)
        this.onPosItemClick(clicked)
      })
      this.map.on('click', 'clusters', async (e) => {
        await this.map.flyTo({
          center: e.features[0].geometry.coordinates,
          zoom: 8
        })
      })
      this.map.on('moveend', () => {
        if (!this.lockSideBar) {
          this.updatePosItems()
        }
      })
      this.map.on('mousemove', 'places', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      })
      this.map.on('mousemove', 'clusters', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      })
      this.map.on("mouseleave", "places", () => {
        this.map.getCanvas().style.cursor = 'grab';
      })
      this.map.on("mouseleave", "clusters", () => {
        this.map.getCanvas().style.cursor = 'grab';
      })
    },

    updatePosItems() {
      this.posItems.splice(0, this.posItems.length, ...this.featuresWithin(this.map))
    },

    centerMap(lng, lat, zoom = 9) {
      this.map.jumpTo({
        center: [lng, lat],
        zoom: zoom,
        transition: {
          duration: 300,
          delay: 0
        }
      });
    },

    featuresWithin (map, relTo = null, min = 3, max = 3) {
      const bounds = map.getBounds()
      const userPosition = this.userPosition ? {lng: this.userPosition[0], lat: this.userPosition[1]} : null
      const center = relTo || map.getCenter()
      // _ne: Object { lng: 22.00167272399753, lat: 46.34641507443908 }
      // _sw: Object { lng: 4.786195276002985, lat: 37.851189864782285 }
      const within = polygon([[
        [bounds._ne.lng, bounds._ne.lat],
        [bounds._ne.lng, bounds._sw.lat],
        [bounds._sw.lng, bounds._sw.lat],
        [bounds._sw.lng, bounds._ne.lat],
        [bounds._ne.lng, bounds._ne.lat]
      ]])
      let feats = pointsWithinPolygon(this.filteredFeatures, within).features
      if (feats.length < min) {
        return this.nClosestFeatures(map, relTo, min)
      }
      let sortedFeats = feats.map(f => {
        f.properties.distance = distance(point([center.lng, center.lat]), f.geometry)
        if (userPosition) {
          f.properties.userPositionDistance = distance(point([userPosition.lng, userPosition.lat]), f.geometry)
        }
        return f
      }).sort((f1, f2) => {
        return f1.properties.distance >= f2.properties.distance ? 1 : -1
      }).slice(0, max)
      .sort((f1, f2) => {
        return f1.properties.userPositionDistance >= f2.properties.userPositionDistance ? 1 : -1
      })
      for (let i = 0; i < sortedFeats.length; i++) {
        sortedFeats[i].order = i
      }
      return sortedFeats
    },

    nClosestFeatures (map, relTo = null, n = 3) {
      const userPosition = this.userPosition ? {lng: this.userPosition[0], lat: this.userPosition[1]} : null
      const center = relTo || map.getCenter()
      let sortedFeats = this.filteredFeatures.features.map(f => {
        f.properties.distance = distance(point([center.lng, center.lat]), f.geometry)
        if (userPosition) {
          f.properties.userPositionDistance = distance(point([userPosition.lng, userPosition.lat]), f.geometry)
        }
        return f
      }).sort((f1, f2) => {
        return f1.properties.distance >= f2.properties.distance ? 1 : -1
      }).slice(0, n)
      .sort((f1, f2) => {
        return f1.properties.userPositionDistance >= f2.properties.userPositionDistance ? 1 : -1
      })
      for (let i = 0; i < sortedFeats.length; i++) {
        sortedFeats[i].order = i
      }
      return sortedFeats
    },

    showPopup (item) {
      if (this.popup) {
        this.popup.remove()
      }
      const popUpBodyNoPhoto = `<div class="pos-popup__address">
                    ${item.properties.street_address === 'undefined' ? '' : item.properties.street_address}
                  </div>
                  <div class="pos-popup__locality p-mx-auto">
                    ${item.properties.postal_code} ${item.properties.locality}
                  </div>`
      const popUpBodyPhoto = `<div class="pos-popup__photo p-mx-auto" style="background-image: url('${item.properties.image_url}');"></div>`
      const popUpBody = item.properties.image_url && item.properties.image_url !== '' ? popUpBodyPhoto : popUpBodyNoPhoto
      this.popup = new mapboxgl.Popup()
          .setLngLat(item.geometry.coordinates)
          .setHTML(`
            <div class="pos-popup">
              <div class="pos-popup__left">
                  <div class="pos-popup__title">${item.properties.name}</div>
                  ${popUpBody}
                  <div class="pos-popup__link p-text-center"><a href="${item.properties.company_url}" title="${item.properties.name}" class="p-button p-button-primary">Voir la fiche détaillée</a></div>
              </div>
            </div>
          `)
          .addTo(this.map);
    },

    onPosItemClick (item) {
      this.filteredFeatures.features.forEach((i) => i.properties.selected = false)
      item.properties.selected = true
      this.$refs.posList.scrollTop = 0
      this.showPopup(item)
      this.map.flyTo({
        center: item.geometry.coordinates,
        zoom: 7.5
      })
    },

    showUserPin() {
      if (this.map.getLayer('user-pos')) {
        this.map.removeLayer('user-pos')
      }
      if (this.map.getSource('user-pos')) {
        this.map.removeSource('user-pos')
      }

      this.map.addSource('user-pos', {
        type: 'geojson',
        data: {
          "type": "FeatureCollection",
          "features": [{
            "type": "Feature",
            "properties": {},
            "geometry": {
              "type": "Point",
              "coordinates": this.userPosition
            }
          }]
        },
        cluster: false
      })

      this.map.addLayer({
        id: 'user-pos',
        type: 'symbol',
        source: 'user-pos',
        layout: {
          'icon-image': 'pin-user',
          'icon-size': 0.08,
          'icon-allow-overlap': true
        }
      })
    }
  }
}
</script>

<style>
#points-of-sale-list {
  width: 100%;
  min-height: var(--map-height);
  overflow-x: hidden;
  overflow-y: hidden;
}
#points-of-sale-map {
  width: 100%;
  height: var(--map-height);
}
@media screen and (max-width: 720px) {
  #points-of-sale-map {
    width: 100%;
    height: 40vh;
  }

  .mapboxgl-popup-content {
    margin-top: -50%;
    z-index: 1000;
  }
}

.pb-posItems-move {
      transition: transform 0.2s
}

.pos-popup__title {
  text-align: center;
  font-weight: bold;
  color: var(--123-green);
  font-size: 1.5rem;
  font-variant: all-small-caps;
  margin-bottom: 0.5rem;
}

.pos-popup__photo {
  width: 188px;
  height: 150px;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 0.5rem;
}

.pos-popup__address {
  font-size: 0.8rem;
}

.pos-popup__locality {
  margin-bottom: 1em;
  font-size: 0.8rem;
}
</style>
